// extracted by mini-css-extract-plugin
export default {"defaultHiddenState":"AppearanceAnim-AppearnaceAnim__defaultHiddenState--P8lov","visibleState":"AppearanceAnim-AppearnaceAnim__visibleState--xBBA_"};